/**
 * Cross-surface signal to reload prioritization dashboard aggregates and widgets.
 * Direct Supabase writes (e.g. SubmitIdea) bypass itemsStore/sync helpers, so they
 * must dispatch explicitly; writes through insertRecord/updateRecord also notify via table allowlist.
 */

export const PRIORITIZATION_DASHBOARD_REFRESH_EVENT = 'prioritization-dashboard-refresh';

export type PrioritizationDashboardRefreshDetail = {
  source?: string;
};

export function dispatchPrioritizationDashboardRefresh(
  detail?: PrioritizationDashboardRefreshDetail
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<PrioritizationDashboardRefreshDetail>(PRIORITIZATION_DASHBOARD_REFRESH_EVENT, {
      detail: detail ?? {},
    })
  );
}

/** Tables whose durable writes affect home dashboard stats or widgets (useDashboardStats + HomeWidgets). */
const DASHBOARD_RELEVANT_TABLES = new Set<string>([
  'items',
  'item_frames',
  'degap_cycles',
  'tracks',
  'item_pools',
  'item_pool_drift_events',
  'prioritization_sessions',
  'attributes',
  'item_relationship_groups',
  'item_relationship_group_memberships',
  'item_relationship_edges',
  'item_mutation_reviews',
  'item_closure_events',
  'lineage_events',
  'lineage_relationship_resolutions',
  'triage_assessments',
  'value_proposals',
  'accepted_values',
  'item_clusters',
  'criteria',
  'workflows',
  'demand_clusters',
  'item_relations',
  'catchball_loops',
  'catchball_proposals',
  'priority_sets',
  'cycle_reports',
  'catchball_loop_transitions',
  'catchball_threads',
  'input_rounds',
  'input_round_items',
  'input_round_participants',
  'prioritization_tasks',
]);

export function notifyPrioritizationDashboardRelevantWrite(tableName: string): void {
  if (DASHBOARD_RELEVANT_TABLES.has(tableName)) {
    dispatchPrioritizationDashboardRefresh({ source: `db:${tableName}` });
  }
}
